// extracted by mini-css-extract-plugin
module.exports = {"balls":"Messaging_balls__3_6vo","wave":"Messaging_wave__4TWY8"};